import React, { Component } from "react";
import { ButtonToolbar, Table, Grid, Row, Col, FormGroup, ControlLabel, Label } from 'react-bootstrap';
import Select from "react-select";

import { ComparisonHelper } from '../../helpers/ComparisonHelper';
import { LoadingSpinner } from "../../LoadingSpinner";
import { TableButton } from '../../TableButton';
import { SortHelper } from "../../helpers/SortHelper";

export class PathStopsActive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            actions: {
                isUpdatingPathstop: false,
            },
            updatedPathStopIndex: []
        }
    }

    renderLabel(value) {
        if (null === value || undefined === value || "" === value) {
            return null;
        }

        return (
            <React.Fragment>
                <Label className="margin-right-5">{value}</Label>
            </React.Fragment>
        );
    }

    renderStopLabel(stop) {
        if (undefined === stop) {
            return "";
        }

        return (
            <div>
                {ComparisonHelper.renderProperty(stop.code, (a) => this.renderLabel(a))}
                {ComparisonHelper.renderProperty(stop.shortName, (a) => this.renderLabel(a))}
                {ComparisonHelper.renderProperty(stop.name)}
            </div>
        );
    }

    renderInSpineLabel(inSpine, pathStop, index) {
        if (undefined === inSpine) {
            return "";
        }

        return inSpine ?
            <TableButton onClick={() => this.updateSpine(pathStop, inSpine, index)} className="ps-btn-green" icon="icon-ok" /> :
            <TableButton onClick={() => this.updateSpine(pathStop, inSpine, index)} className="ps-btn-red" icon="icon-error" />;
    }

    updateSpine(pathStop, inSpine, index) {
        const { actions, updatedPathStopIndex } = this.state;

        actions.isUpdatingPathstop = true;

        this.props.onSavePathStopSpine(pathStop, !inSpine, (a) => this.updateSpineCallback(index));

        this.setState({
            actions: actions,
            updatedPathStopIndex: [
                ...updatedPathStopIndex,
                index
            ]
        });
    }

    updateSpineCallback(index) {
        const { actions, updatedPathStopIndex } = this.state;
        const updatedArray = updatedPathStopIndex.filter((value) => value !== index);

        actions.isUpdatingPathstop = false;

        this.setState({
            actions: actions,
            updatedPathStopIndex: updatedArray,
        });

    }

    renderRegionsLabel(regions) {
        if (!Array.isArray(regions)) {
            return "";
        }

        return regions.map(region => region.name).join(" | ");
    }

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderTable() {
        const { pathSelected } = this.props;
        const { actions, updatedPathStopIndex } = this.state;

        if (undefined === pathSelected) {
            return null;
        }

        const { pathStops, isLoadingPathStops } = this.props;

        return (
            <div className="table-loading">
                <Table responsive striped hover>
                    <thead>
                        <tr>
                            <th>Paragem</th>
                            <th>Ordem</th>
                            <th>Distância</th>
                            <th>Duração</th>
                            <th>Espinha</th>
                            <th>Regiões</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody className={isLoadingPathStops ? "overlay" : ""} onDrop={(e) => this.props.onDrop(e)}>
                        {
                            pathStops.map((pathStop, idx) =>
                                <tr key={`pathStop-${idx}`}
                                    className={ComparisonHelper.getRowClass(pathStop.stopOrder)}
                                    draggable={true}
                                    onDragOver={(a) => this.props.onDragOver(a)}
                                    onDragStart={(e) => this.props.onDragStart(e, idx)}>
                                    {/*  */}
                                    <td data-value={idx}>{this.renderStopLabel(pathStop.stop)}</td>
                                    <td data-value={idx}>{ComparisonHelper.renderProperty(pathStop.stopOrder)}</td>
                                    <td data-value={idx}>{ComparisonHelper.renderProperty(pathStop.prevDistance)}</td>
                                    <td data-value={idx}>{ComparisonHelper.renderProperty(pathStop.segmentBreakDuration)}</td>
                                    <td data-value={idx}>{actions.isUpdatingPathstop && updatedPathStopIndex.some(x => x === idx) ?
                                        <LoadingSpinner
                                            className="psLoading" /> :
                                        ComparisonHelper.renderProperty(pathStop.inSpine, (a) => this.renderInSpineLabel(a, pathStop, idx))} </td>
                                    <td data-value={idx}>{ComparisonHelper.renderProperty(pathStop.regions, (a) => this.renderRegionsLabel(a))}</td>

                                    <td>
                                        <ButtonToolbar className="pull-right">
                                            <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(pathStop)} />
                                            <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(pathStop)} />
                                        </ButtonToolbar>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>

                {this.renderLoading(isLoadingPathStops)}
            </div>
        );
    }

    renderPaths() {
        const { lineSelected } = this.props;

        if (undefined === lineSelected || null === lineSelected) {
            return null;
        }

        const { isLoadingPaths } = this.props;

        if (isLoadingPaths) {
            return <LoadingSpinner />;
        }

        const { paths, pathSelected, isLoadingPathStops } = this.props;

        return (
            <FormGroup controlId="formPath">
                <Row className="row-dropdown">
                    <Col sm={1}>
                        <ControlLabel className="control-label-dropdown">Percurso</ControlLabel>
                    </Col>
                    <Col sm={11}>
                        <Select
                            className="custom-multiselect"
                            placeholder="Selecione um percurso"
                            isDisabled={isLoadingPathStops}
                            noOptionsMessage={() => "Sem Percursos Configurados"}
                            onChange={(e) => this.props.onChangePath(e)}
                            options={paths}
                            isMulti={false}
                            isClearable={true}
                            getOptionValue={value => value.id}
                            getOptionLabel={label => label.code}
                            value={pathSelected}
                        />
                    </Col>
                </Row>
            </FormGroup>
        )
    }

    render() {
        const { lines, lineSelected, isLoadingPaths } = this.props;

        return (
            <Grid fluid className="table-small-screens">
                <FormGroup controlId="formLine" className="margin-top-15">
                    <Row className="row-dropdown">
                        <Col sm={1} >
                            <ControlLabel className="control-label-dropdown">Linha</ControlLabel>
                        </Col>
                        <Col sm={11}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Selecione uma linha"
                                isDisabled={isLoadingPaths}
                                noOptionsMessage={() => "Sem Linhas Configuradas"}
                                onChange={(e) => this.props.onChangeLine(e)}
                                options={lines.sort(SortHelper.defaultLineSorter)}
                                isMulti={false}
                                isClearable={true}
                                getOptionValue={value => value.id}
                                getOptionLabel={label => `${label.code} | ${label.goName}`}
                                value={lineSelected}
                            />
                        </Col>
                    </Row>
                </FormGroup>
                {this.renderPaths()}
                {this.renderTable()}
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/pathStops/PathStopsActive.js